import React from 'react';
import { Conversation } from '../utils/types';
import ConversationList from './ConversationList';

interface SidebarProps {
    conversations: Conversation[];
    activeConversation: number;
    searchQuery: string;
    onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onConversationSelect: (id: number) => void;
    onNewConversation: () => void;
    onEditConversation: (id: number, newTitle: string) => void;
    onDeleteConversation: (id: number) => void;
    isOpen: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({
                                             conversations,
                                             activeConversation,
                                             searchQuery,
                                             onSearchChange,
                                             onConversationSelect,
                                             onNewConversation,
                                             onEditConversation,
                                             onDeleteConversation,
                                             isOpen
                                         }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="h-full bg-gray-100 border-r border-gray-200 overflow-hidden">
            <ConversationList
                conversations={conversations}
                activeConversation={activeConversation}
                searchQuery={searchQuery}
                onSearchChange={onSearchChange}
                onConversationSelect={onConversationSelect}
                onNewConversation={onNewConversation}
                onEditConversation={onEditConversation}
                onDeleteConversation={onDeleteConversation}
            />
        </div>
    );
};

export default Sidebar;